import { selectAuthUserData } from '@src/data/Auth/selectors'
import { isShiftPostingRedesignEnabledForUser } from '@src/helpers/shiftPostingRedesign'
import { AsyncShiftFullEdit, AsyncShiftFullEditV2 } from '@src/ui/pages'
import { useSelector } from 'react-redux'

export const EditShiftAdmin = () => {
  const authData = useSelector(selectAuthUserData)
  const isShiftPostingRedesignEnabled = isShiftPostingRedesignEnabledForUser(authData)
  return isShiftPostingRedesignEnabled ? <AsyncShiftFullEditV2 /> : <AsyncShiftFullEdit />
}
